<div
  class="gw-flex gw-min-h-0 gw-w-full gw-flex-1 gw-flex-col gw-overflow-hidden"
  *ngIf="flowActive"
>
  <div
    class="gw-flex gw-min-h-0 gw-flex-1 gw-flex-col gw-overflow-y-auto gw-px-medium"
  >
    <ng-container [ngSwitch]="step">
      <app-bank-slip-step-digitable
        *ngSwitchCase="'digitable'"
        [form]="form"
        [submitted]="submitted"
        (scanRequested)="scanRequested.emit()"
      ></app-bank-slip-step-digitable>

      <app-bank-slip-step-review
        *ngSwitchCase="'review'"
        [validated]="validated"
        [amountBreakdown]="amountBreakdown"
        [description]="descriptionValue"
        [insufficientBalance]="insufficientBalance"
      ></app-bank-slip-step-review>

      <app-bank-slip-step-proof
        *ngSwitchCase="'payment_proof'"
        [validated]="validated"
        [receiverPaymentInfo]="createdWithdrawal?.receiverPaymentInfo ?? null"
        [isWithdrawalPolling]="isWithdrawalPolling"
        [isWithdrawalSuccess]="isWithdrawalSuccess"
        [isWithdrawalFailed]="showWithdrawalFailureUi"
        [statusErrorMessage]="withdrawalStatusErrorMessage"
        [paymentReceipt]="paymentReceipt"
        [paymentMetadata]="paymentMetadata"
        [amount]="amountBreakdown?.amount ?? null"
        [calculatedFee]="amountBreakdown?.calculatedFee ?? null"
        [finalAmount]="amountBreakdown?.finalAmount ?? null"
      ></app-bank-slip-step-proof>
    </ng-container>
  </div>

  <ng-container *ngIf="shellKind === 'dialog'">
    <div
      class="gw-h-px gw-w-full gw-bg-border-abnormal gw-mb-medium"
      aria-hidden="true"
    ></div>
    <footer
      class="gw-shrink-0 gw-border-t gw-border-border-normal gw-bg-background-base gw-px-medium gw-pt-medium gw-pb-medium"
    >
      <ng-container *ngTemplateOutlet="actionFooter"></ng-container>
    </footer>
  </ng-container>
</div>

<ng-template #actionFooter>
  <div
    class="gw-h-px gw-w-full gw-bg-border-abnormal gw-mb-medium"
    aria-hidden="true"
  ></div>

  <div class="gw-px-medium">
    <ng-container [ngSwitch]="step">
      <ng-container *ngSwitchCase="'digitable'">
        <gatewee-button
          class="gw-w-full"
          [title]="'common.actions.proceed' | translate"
          [loading]="isValidating"
          [disabled]="!canContinueDigitable"
          (clicked)="onContinueFromDigitable()"
        ></gatewee-button>
      </ng-container>

      <ng-container *ngSwitchCase="'review'">
        <div
          *ngIf="transferErrorMessage"
          class="gw-mb-medium gw-rounded-lg gw-border gw-border-status-negative gw-bg-status-negative-pale gw-p-medium gw-text-text-negative gw-text-sm"
          role="alert"
        >
          {{ transferErrorMessage }}
        </div>
        <div
          class="gw-flex gw-items-center gw-justify-between gw-gap-small"
          role="group"
          [attr.aria-label]="
            'features.withdrawals.modalBankSlip.actions.send' | translate
          "
        >
          <div class="gw-flex gw-flex-col">
            <span class="gw-text-text-primary gw-text-lg gw-font-extrabold">
              {{ amountBreakdown?.amount | currency : 'BRL' }}
            </span>
            <span class="gw-text-text-secondary gw-font-normal">
              {{
                'features.withdrawals.modalBankSlip.totalAmountLabel'
                  | translate
              }}
            </span>
          </div>
          <gatewee-button
            [title]="
              'features.withdrawals.modalBankSlip.actions.send' | translate
            "
            [loading]="isSubmitting"
            [disabled]="isSubmitting || insufficientBalance || !walletId"
            (clicked)="onSubmit()"
          ></gatewee-button>
        </div>
      </ng-container>

      <ng-container *ngSwitchCase="'payment_proof'">
        <gatewee-button
          class="gw-w-full"
          [title]="
            'features.withdrawals.modalBankSlip.proofConclude' | translate
          "
          [disabled]="isWithdrawalPolling"
          (clicked)="onProofConclude()"
        ></gatewee-button>
      </ng-container>
    </ng-container>
  </div>
</ng-template>
